module.exports = __webpack_public_path__ + "static/img/7.ad2984a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/10/sp/7.png
// module id = H40G
// module chunks = 0